<template>
  <div class="gzh-menu">
    <div class="module-item-style">
      <div class="module-item-title">自定义微信菜单</div>
      <div class="join-tips">你可以在这里添加或修改你的微信菜单，可添加最多 3 个一级菜单，每个一级菜单下可添加最多 5 个子菜单</div>
      <div class="menu-container">
        <div class="child-menu-container"></div>
        <div class="first-menu-container">
          <div class="first-menu-item" v-for="(firstMenu, i) in menuData" :key="'first'+i">
            <ul class="second-child-menu-container">
              <li
                class="second-child-menu-item"
                @click="editsecondMenu(secondMenu,i,j)"
                v-for="(secondMenu, j) in firstMenu.sub_button"
                :key="'second'+i+j"
              >
                {{secondMenu.name}}
                <i class="el-icon-edit-outline edit-child"></i>
              </li>
              <li
                class="second-child-menu-item add"
                v-if="firstMenu.sub_button.length < 5 && firstMenu.key == null && firstMenu.type == null"
                @click="addsecondMenu(i)"
              >
                <i class="el-icon-plus"></i> 添加子菜单
              </li>
            </ul>
            <div class="firstMenu-name" @click="editFirstMenu(firstMenu, i)">
              {{firstMenu.name}}
              <i class="el-icon-edit-outline"></i>
            </div>
          </div>
          <div class="first-menu-item add" v-if="menuData.length < 3" @click="addFirstMenu">
            <i class="el-icon-plus"></i> 添加一级菜单栏
          </div>
        </div>
      </div>
      <div class="opertion-container">
        <span class="wl-btn" @click="saveMenuData">确定</span>
        <span class="wl-btn-normal menu-cancel" @click="cancelMenu">取消</span>
      </div>
    </div>

    <el-dialog
      :title="dialogTitle"
      width="570px"
      @close="menuDialogClose"
      class="menu-dialog"
      :visible.sync="dialogTableVisible"
    >
      <div class="dialog-content-container">
        <div class="menu-name-box" v-if="menuLevel == 'first'">
          <el-input
            type="text"
            class="menu-name-input"
            placeholder="请输入内容"
            v-model="formData.menuName"
            maxlength="4"
            show-word-limit
          ></el-input>
          <div class="menu-name-tips">
            <span>*</span>
            不超过4个汉字
          </div>
        </div>
        <div class="menu-name-box" v-if="menuLevel == 'second'">
          <el-input
            type="text"
            class="menu-name-input"
            placeholder="请输入内容"
            v-model="formData.menuName"
            maxlength="7"
            show-word-limit
          ></el-input>
          <div class="menu-name-tips">
            <span>*</span>
            不超过7个汉字
          </div>
        </div>
        <div class="menu-action" v-if="menuLevel == 'first'" style="padding-bottom: 0;">
          <div>子菜单：</div>
          <el-radio-group v-model="formData.needChild" @change="neeChildMenu">
            <el-radio label="yes">需要</el-radio>
            <el-radio label="no">不需要</el-radio>
          </el-radio-group>
        </div>
        <div v-if="formData.needChild == 'no'">
          <div class="menu-action">
            <div>菜单动作：</div>
            <el-radio-group v-model="formData.action" @change="actionChange">
              <el-radio label="msg">发送消息</el-radio>
              <el-radio label="url">跳转网页</el-radio>
            </el-radio-group>
          </div>
          <div v-if="formData.action == 'msg'">
            <el-radio-group
              v-model="formData.menuType"
              style="margin-bottom: 30px;"
              @change="menuTypeChange"
            >
              <el-radio-button label="text">文字</el-radio-button>
              <el-radio-button label="image">图片</el-radio-button>
            </el-radio-group>

            <div class="menu-type-container">
              <el-input
                v-if="formData.menuType == 'text'"
                class="content-text"
                type="textarea"
                rows="10"
                resize="none"
                maxlength="500"
                show-word-limit
                placeholder="请输入内容"
                v-model="formData.menuContent"
              ></el-input>
              <div class="content-image" v-if="formData.menuType == 'image'">
                <div class="upload-container" @click="menuUpload" v-if="formData.menuContent == ''">
                  <i class="el-icon-plus avatar-uploader-icon"></i>
                  <input
                    type="file"
                    ref="menuFileInput"
                    @change="menuFileChange"
                    style="display: none;"
                  />
                </div>
                <div v-else class="img-url">
                  <i class="el-icon-circle-close img-del" @click="deImg"></i>
                  <img :src="formData.menuContent" alt />
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <el-input
              class="content-text"
              type="textarea"
              rows="10"
              resize="none"
              maxlength="500"
              show-word-limit
              placeholder="请输入跳转连接"
              v-model="formData.menuContent"
            ></el-input>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button
          type="danger"
          v-if="dialogType === 'edit'"
          @click="deleteMenu(deleteFirstIndex, deleteSecondIndex)"
        >删 除</el-button>
        <el-button @click="menuDialogClose">取 消</el-button>
        <el-button type="primary" @click="addMenuData">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import qs from "qs";
export default {
  name: "gzh-menu",
  data() {
    return {
      gzhId: this.$route.query.id,
      dialogTableVisible: false,
      accept: "image/gif, image/jpeg, image/png, image/jpg",
      dialogTitle: "添加菜单",
      dialogType: "add",
      menuData: [],
      menuLevel: "", // 菜单等级： first、second
      formData: {
        menuName: "",
        needChild: "no",
        action: "msg",
        menuType: "text",
        menuContent: ""
      },
      initPostData: {
        menu: {
          button: []
        },
        message: {},
        gzhId: this.$route.query.id
      },
      menuInfo: {
        summary: null,
        author: null,
        cover: null,
        title: null,
        content: null,
        type: null,
        link: null,
        image: null,
        keyId: null
      },
      postData: {
        menu: {
          button: []
        },
        message: {},
        gzhId: this.$route.query.id
      },
      editIndex: "",
      editChildIndex: "",
      canPost: false,
      deleteFirstIndex: -1,
      deleteSecondIndex: -1
    };
  },
  created() {
    this.getMenuData();
  },
  mounted() {},
  methods: {
    /**
     * 获取菜单数据
     */
    getMenuData() {
      this.$http
        .getMenusAPI({
          gzhId: this.gzhId
        })
        .then(res => {
          if (res.status == 1) {
            this.postData.menu = res.data.menu;
            this.postData.message = res.data.message;
            this.menuData = res.data.menu.button;
          } else {
            this.$message({
              message: res.msg,
              type: "error"
            });
          }
        });
    },
    // 删除菜单
    deleteMenu(firstIndex, secondIndex) {
      console.log('firstIndex=', firstIndex)
      console.log('secondIndex=', this.postData)
      if (firstIndex >= 0) {
        if (secondIndex >= 0) {
            if (this.postData.menu.button[firstIndex].sub_button[secondIndex].key) {
              delete this.postData.message[this.postData.menu.button[firstIndex].sub_button[secondIndex].key]
            }

          this.postData.menu.button[firstIndex].sub_button.splice(secondIndex, 1);
        } else {
          if (this.postData.menu.button[firstIndex].key) {
            delete this.postData.message[this.postData.menu.button[firstIndex].key]
          }

          this.postData.menu.button.splice(firstIndex, 1);
        }
      }

      this.menuData = this.postData.menu.button;
      this.menuDialogClose();
    },
    /**
     * dialog关闭
     */
    menuDialogClose() {
      this.deleteFirstIndex = -1;
      this.deleteSecondIndex = -1;
      this.dialogTableVisible = false;
    },
    /**
     * 添加一级菜单
     */
    addFirstMenu() {
      this.menuLevel = "first";
      this.dialogTitle = "添加一级菜单";
      this.dialogType = "add";
      this.dialogTableVisible = true;
      this.formData = {
        menuName: "",
        needChild: "no",
        action: "msg",
        menuType: "text",
        menuContent: ""
      };
      this.menuInfo = {
        summary: null,
        author: null,
        cover: null,
        title: null,
        content: null,
        type: null,
        link: null,
        image: null,
        keyId: null
      };
    },
    /**
     * 编辑一级菜单
     */
    editFirstMenu(item, index) {
      this.deleteFirstIndex = index;
      this.menuInfo = {
        summary: null,
        author: null,
        cover: null,
        title: null,
        content: null,
        type: null,
        link: null,
        image: null,
        keyId: null
      };
      this.editIndex = index;
      this.formData.menuName = item.name;
      if (item.key == null && item.type == null) {
        this.formData.needChild = "yes";
      } else {
        this.formData.needChild = "no";
        if (item.type == "click") {
          this.formData.action = "msg";
          let menuMSg = this.postData.message;
          for (let key in menuMSg) {
            if (key == item.key) {
              this.formData.menuType = menuMSg[key].type;
              if (menuMSg[key].type == "text") {
                this.formData.menuType = "text";
                this.formData.menuContent = menuMSg[key].content;
              } else if (menuMSg[key].type == "image") {
                this.formData.menuType = "image";
                this.formData.menuContent = menuMSg[key].content;
              }
            }
          }
        } else if (item.type == "view") {
          this.formData.action = "url";
          this.formData.menuContent = item.url;
        }
      }
      this.menuLevel = "first";
      this.dialogTitle = "编辑一级菜单";
      this.dialogType = "edit";
      this.dialogTableVisible = true;
    },
    /**
     * 添加二级级菜单
     */
    addsecondMenu(index) {
      this.editIndex = index;
      this.dialogTitle = "添加二级菜单";
      this.menuLevel = "second";
      this.dialogType = "add";
      this.formData = {
        menuName: "",
        needChild: "no",
        action: "msg",
        menuType: "text",
        menuContent: ""
      };
      this.dialogTableVisible = true;
      this.menuInfo = {
        summary: null,
        author: null,
        cover: null,
        title: null,
        content: null,
        type: null,
        link: null,
        image: null,
        keyId: null
      };
    },
    /**
     * 编辑二级级菜单
     */
    editsecondMenu(item, pIndex, index) {
      // pIndex:父级索引，index：当前子级索引
      this.deleteFirstIndex = pIndex;
      this.deleteSecondIndex = index;
      this.menuInfo = {
        summary: null,
        author: null,
        cover: null,
        title: null,
        content: null,
        type: null,
        link: null,
        image: null,
        keyId: null
      };
      this.editIndex = pIndex;
      this.editChildIndex = index;
      this.menuLevel = "second";
      this.dialogTitle = "编辑二级菜单";
      this.dialogType = "edit";
      this.dialogTableVisible = true;
      this.formData.menuName = item.name;
      if (item.type == "click") {
        this.formData.action = "msg";
        let menuMSg = this.postData.message;
        for (let key in menuMSg) {
          if (key == item.key) {
            this.formData.menuType = menuMSg[key].type;
            if (menuMSg[key].type == "text") {
              this.formData.menuType = "text";
              this.formData.menuContent = menuMSg[key].content;
            } else if (menuMSg[key].type == "image") {
              this.formData.menuType = "image";
              this.formData.menuContent = menuMSg[key].content;
            }
          }
        }
      } else if (item.type == "view") {
        this.formData.action = "url";
        this.formData.menuContent = item.url;
      }
    },
    /**
     *
     * 是否需要子菜单：yes-no
     * */
    neeChildMenu(val) {
      this.formData.needChild = val;
      this.formData.action = "msg";
      this.formData.menuType = "text";
      this.formData.menuContent = "";
    },
    /**
     * 发送消息-跳转网页
     * */
    actionChange(val) {
      this.formData.action = val;
      this.formData.menuContent = "";
      this.formData.menuType = "text";
    },
    /**
     *
     * 菜单类型切换：图片-文本
     * */
    menuTypeChange(val) {
      this.formData.menuType = val;
      this.formData.menuContent = "";
    },
    menuUpload() {
      this.$refs.menuFileInput.click();
    },
    /**
     * 上传图片
     * @param e
     * @returns {boolean}
     */
    menuFileChange(e) {
      let img = e.target.files[0];
      let type = img.type;
      let size = img.size;
      if (this.accept.indexOf(type) == -1) {
        this.$message({
          showClose: true,
          message:
            "图片格式不正确，请选择我们支持的图片格式 .gif, .jpeg, .png, .jpg",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      if (size > 5242880) {
        this.$message({
          showClose: true,
          message: "请选择5M以内的图片！",
          type: "error",
          duration: 3 * 1000
        });
        return false;
      }
      let formdata = new FormData();
      formdata.set("file", img);
      this.$http.uploadImageAPI(formdata).then(res => {
        if (res.status == 1) {
          this.formData.menuContent = res.data;
          this.$message({
            message: res.msg,
            type: "success"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    /**
     * 关注回复-删除图片
     * */
    deImg() {
      this.formData.menuContent = "";
    },
    addMenuData() {
      let key = "wlmsg_" + new Date().getTime();
      let addData = this.formData;
      this.menuInfo.keyId = key;
      if (this.$utils.u_isEmpty(addData.menuName)) {
        this.$message({
          message: "菜单名字不能为空",
          type: "error"
        });
        return false;
      }
      if (addData.needChild == "no") {
        if (addData.action == "msg") {
          if (this.$utils.u_isEmpty(addData.menuContent)) {
            if (addData.menuType == "text") {
              this.$message({
                message: "文字消息不能为空",
                type: "error"
              });
              return false;
            } else if (addData.menuType == "image") {
              this.$message({
                message: "图片消息不能为空",
                type: "error"
              });
              return false;
            }
          }
        } else if (addData.action == "url") {
          if (this.$utils.u_isEmpty(addData.menuContent)) {
            this.$message({
              message: "跳转网页链接不能为空",
              type: "error"
            });
            return false;
          }
        }
      }

      if (this.dialogType == "add") {
        //添加
        if (this.menuLevel == "first") {
          // 添加一级菜单
          let firstMenuObj = {
            name: null,
            sub_button: [],
            key: null,
            type: null,
            url: null,
          };
          firstMenuObj.name = addData.menuName;
          if (addData.needChild == "no") {
            // 不需要子菜单
            firstMenuObj.sub_button = [];
            if (addData.action == "msg") {
              // 图片或文字
              firstMenuObj.type = "click";
              firstMenuObj.key = key;
              if (addData.menuType == "text") {
                // 文本
                this.menuInfo.type = "text";
                this.menuInfo.content = addData.menuContent;
              } else {
                // 图片
                this.menuInfo.type = "image";
                this.menuInfo.content = addData.menuContent;
              }
              this.postData.message[key] = this.menuInfo;
            } else {
              // 连接
              firstMenuObj.type = "view";
              firstMenuObj.url = addData.menuContent;
              this.menuInfo.type = "text";
              this.menuInfo.link = addData.menuContent;
            }
          } else {
            // 需要子菜单
          }
          this.postData.menu.button.push(firstMenuObj);
        } else {
          // 添加二级菜单
          let secondMenuObj = {
            name: null,
            sub_button: [],
            key: null,
            type: null,
            url: null,
          };
          secondMenuObj.sub_button = [];
          secondMenuObj.name = addData.menuName;
          if (addData.action == "msg") {
            // 图片或文字
            secondMenuObj.type = "click";
            secondMenuObj.key = key;
            if (addData.menuType == "text") {
              // 文本
              this.menuInfo.type = "text";
              this.menuInfo.content = addData.menuContent;
            } else {
              // 图片
              this.menuInfo.type = "image";
              this.menuInfo.content = addData.menuContent;
            }
            this.postData.message[key] = this.menuInfo;
          } else {
            // 连接
            secondMenuObj.type = "view";
            secondMenuObj.url = addData.menuContent;
            this.menuInfo.type = "text";
            this.menuInfo.link = addData.menuContent;
          }

          this.postData.menu.button[this.editIndex].sub_button.push(
            secondMenuObj
          );
        }

        this.menuData = this.postData.menu.button;
      } else {
        // 编辑
        if (this.menuLevel == "first") {
          // 编辑一级菜单
          let editFirstMenu = this.menuData[this.editIndex];
          editFirstMenu.name = addData.menuName;
          if (addData.needChild == "no") {
            // 不需要子菜单
            editFirstMenu.sub_button.map(item => {
              // 不需要子菜单后，删除下面的子菜单数据
              if (item.key) {
                delete this.postData.message[item.key];
              }
            });
            editFirstMenu.sub_button = [];
            if (addData.action == "msg") {
              // 图片或文字
              editFirstMenu.type = "click";
              delete editFirstMenu.url;
              if (addData.menuType == "text") {
                // 文本
                this.menuInfo.type = "text";
                this.menuInfo.content = addData.menuContent;
              } else {
                // 图片
                this.menuInfo.type = "image";
                this.menuInfo.content = addData.menuContent;
              }
              if (editFirstMenu.key) {
                this.menuInfo.keyId = editFirstMenu.key;
                this.postData.message[editFirstMenu.key] = this.menuInfo;
              } else {
                this.postData.message[key] = this.menuInfo;
                editFirstMenu.key = key;
              }
            } else {
              // 连接
              editFirstMenu.type = "view";
              editFirstMenu.url = addData.menuContent;
              this.menuInfo.type = "text";
              this.menuInfo.link = addData.menuContent;
            }
          } else {
            // 需要子菜单
            delete this.postData.message[editFirstMenu.key];
            editFirstMenu.key = null;
            editFirstMenu.type = null;
          }
          this.postData.menu.button.splice(this.editIndex, 1, editFirstMenu);
        } else {
          // 编辑二级菜单
          let editSecondMenu = this.menuData[this.editIndex].sub_button[
            this.editChildIndex
          ];
          editSecondMenu.name = addData.menuName;
          if (addData.action == "msg") {
            // 图片或文字
            editSecondMenu.type = "click";
            delete editSecondMenu.url;
            if (addData.menuType == "text") {
              // 文本
              this.menuInfo.type = "text";
              this.menuInfo.content = addData.menuContent;
            } else {
              // 图片
              this.menuInfo.type = "image";
              this.menuInfo.content = addData.menuContent;
            }
            if (editSecondMenu.key) {
              this.menuInfo.keyId = editSecondMenu.key;
              this.postData.message[editSecondMenu.key] = this.menuInfo;
            } else {
              this.postData.message[key] = this.menuInfo;
              editSecondMenu.key = key;
            }
          } else {
            // 连接
            delete editSecondMenu.key;
            editSecondMenu.type = "view";
            editSecondMenu.url = addData.menuContent;
            this.menuInfo.type = "text";
            this.menuInfo.link = addData.menuContent;
          }

          this.postData.menu.button[this.editIndex].sub_button.splice(
            this.editChildIndex,
            1,
            editSecondMenu
          );
        }
      }
      this.menuData = this.postData.menu.button;
      this.menuDialogClose();
    },
    saveMenuData() {
      // if (this.postData.menu.button.length == 0) {
      //   this.$message({
      //     message: "未添加任何数据",
      //     type: "error"
      //   });
      //   return false;
      // }
      let menu = this.postData.menu.button;
      for (let i = 0; i < menu.length; i++) {
        let item = menu[i];
        if (
          item.key == null &&
          item.type == null &&
          item.sub_button.length == 0
        ) {
          this.$message({
            message: "请至少添加一个子菜单",
            type: "error"
          });
          return false;
        }
      }
      let postParams = {};
      postParams.gzhId = this.postData.gzhId;
      console.log("menu=", this.postData.menu);
      console.log("message=", this.postData.message);
      postParams.menu = JSON.stringify(this.postData.menu);
      postParams.message = JSON.stringify(this.postData.message);
      this.$http.saveMenusAPI(postParams).then(res => {
        if (res.status == 1) {
          this.$message({
            message: res.msg,
            type: "success"
          });
          this.$router.push({
            path: "/setting-join-gzh"
          });
        } else {
          this.$message({
            message: res.msg,
            type: "error"
          });
        }
      });
    },
    cancelMenu() {
      this.getMenuData();
    }
  }
};
</script>

<style lang="scss">
.gzh-menu {
  .join-tips {
    font-size: 12px;
    color: #999;
    line-height: 40px;
  }

  .menu-container {
    height: 380px;
    width: 660px;
    border: 1px solid #e4e7ed;
    border-radius: $mainBorderRadius;
    margin-bottom: 44px;
  }

  .menu-container {
    display: flex;
    flex-direction: column;

    .child-menu-container {
      flex: 1;
      background-color: #fafafa;
    }

    .first-menu-container {
      height: 60px;
      padding: 11px 0;
      display: flex;
      align-items: center;
      font-size: 13px;
      color: #333;

      .first-menu-item {
        width: 33%;
        text-align: center;
        cursor: pointer;
        position: relative;

        &.add {
          color: $mainColor;
        }

        .firstMenu-name {
          min-height: 14px;
          i {
            display: none;
          }

          &:hover {
            i {
              display: inline-block;
            }
          }
        }

        .second-child-menu-container {
          position: absolute;
          bottom: 40px;
          left: 0;
          right: 0;

          .second-child-menu-item {
            width: 150px;
            height: 44px;
            font-size: 13px;
            color: #333333;
            line-height: 44px;
            background: rgba(255, 255, 255, 1);
            border: 1px solid rgba(228, 231, 237, 1);
            border-radius: 4px;

            &.add {
              color: $mainColor;
            }

            .edit-child {
              display: none;
            }

            &:hover {
              .edit-child {
                display: inline-block;
              }
            }
          }

          .second-child-menu-item + .second-child-menu-item {
            margin-top: 7px;
          }
        }
      }

      .first-menu-item + .first-menu-item {
        border-left: 2px solid #eeeeee;
      }
    }
  }

  .opertion-container {
    .menu-cancel {
      margin-left: 40px;
    }
  }

  .menu-dialog {
    .dialog-content-container {
      .menu-action {
        padding: 26px 0;
        display: flex;
      }

      .menu-name-box {
        display: flex;
        align-items: center;

        .menu-name-input {
          width: 340px;
        }

        .menu-name-tips {
          padding-left: 21px;
          font-size: 12px;
          color: #999;

          span {
            color: #fd4949;
          }
        }
      }

      .content-image {
        height: 222px;
        background-color: rgba(250, 250, 250, 1);
        border-radius: $mainBorderRadius;
        display: flex;
        align-items: center;

        .img-url {
          width: 80%;
          height: 80%;
          margin: 0 auto;
          position: relative;

          .img-del {
            position: absolute;
            top: -6px;
            right: -6px;
            font-size: 20px;
            cursor: pointer;
          }

          img {
            width: 100%;
            height: 100%;
          }
        }

        .upload-container {
          width: 150px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: $mainBorderRadius;
          border: 1px solid #e4e7ed;
          margin: 0 auto;
          font-size: 40px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
